import styled, { css } from "styled-components";

import { UserRole } from "types/BETypes";

import { Text } from "uikit";

export const Container = styled.div``;

export const Role = styled(Text)<{ userRole: UserRole }>`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.size.caption};

  ${({ userRole }) => {
    if (userRole === UserRole.EMPLOYEE) {
      return css`
        color: ${({ theme }) => theme.colors.colorsNew.blue.blue};
      `;
    }

    return css`
      background: ${({ theme }) => theme.colors.colorsNew.gradient.green};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    `;
  }}
`;
